import React, { useState } from 'react'
import t from '../../translations/i18n'
import '../../scss/_contact.scss'
import Spiner from '../../components/modals/Spiner'
import generalLogic from '../../functions/logic/generalLogic'
import { useSnackbar } from 'notistack'

export default function Contact() {
  const [nombres, setNombres] = useState('')
  const [telefono, setTelefono] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [messages, setMessages] = useState('')
  const { enqueueSnackbar } = useSnackbar()
  const [spiner, setSpiner] = useState(false)

  const handleSubmitContac = async (e) => {
    e.preventDefault()
    setSpiner(true)
    const data = {
      nombres: nombres,
      telefono: telefono,
      email: email,
      subject: subject,
      messages: messages,
      ip: localStorage.getItem('ip')
    }

    const response = await generalLogic.sendContactLogic(data)
    enqueueSnackbar(response.data.message, {
      variant: response.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })

    setSpiner(false)
    if (response.success) {
      setTimeout(() => {
        window.location.reload()
      }, 5000)
    }
  }

  return (
    <>
      <Spiner opt={spiner} />

      <div className="page-content easybuy-contact-page">
        <div className="container">
          <div className="easybuy-contact-card">
            <div className="easybuy-contact-header text-center">
              <span className="easybuy-contact-badge">
                <i className="la la-comments"></i>
                {t('contact.Tittle')}
              </span>

              <h2>{t('contact.Tittle')}</h2>

              <p>{t('contact.Parrafo')}</p>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-9">
                <form
                  onSubmit={handleSubmitContac}
                  className="contact-form easybuy-contact-form"
                >
                  <div className="row">
                    <div className="col-12">
                      <div className="easybuy-input-group">
                        <label htmlFor="cname">{t('general.Name')}</label>

                        <input
                          type="text"
                          className="form-control"
                          id="cname"
                          placeholder={t('general.Name')}
                          required
                          maxLength={50}
                          value={nombres}
                          onChange={(e) => {
                            setNombres(e.target.value.replace(/[^a-z\s]/gi, ''))
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="easybuy-input-group">
                        <label htmlFor="cphone">{t('general.Phone')}</label>

                        <input
                          type="tel"
                          className="form-control"
                          id="cphone"
                          placeholder={t('general.Phone')}
                          value={telefono}
                          maxLength={10}
                          required
                          onChange={(e) => {
                            setTelefono(e.target.value.replace(/\D/g, ''))
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="easybuy-input-group">
                        <label htmlFor="cemail">{t('general.Email')}</label>

                        <input
                          type="email"
                          className="form-control"
                          id="cemail"
                          maxLength={100}
                          placeholder={t('general.Email')}
                          required
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value)
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="easybuy-input-group">
                        <label htmlFor="csubject">{t('general.Subject')}</label>

                        <input
                          type="text"
                          className="form-control"
                          id="csubject"
                          placeholder={t('general.Subject')}
                          value={subject}
                          required
                          maxLength={100}
                          onChange={(e) => {
                            setSubject(e.target.value)
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="easybuy-input-group">
                        <label htmlFor="cmessage">{t('general.Message')}</label>

                        <textarea
                          className="form-control"
                          cols="30"
                          rows="5"
                          id="cmessage"
                          required
                          maxLength={3000}
                          placeholder={t('general.Message')}
                          value={messages}
                          onChange={(e) => {
                            setMessages(e.target.value)
                          }}
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="easybuy-contact-submit text-center">
                    <button type="submit" className="easybuy-contact-button">
                      <span>{t('general.Submit')}</span>
                      <i className="icon-long-arrow-right"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="row easybuy-contact-info">
              <div className="col-md-4">
                <div className="easybuy-info-box">
                  <div className="easybuy-info-icon">
                    <i className="la la-map-marker"></i>
                  </div>

                  <div>
                    <h3>{t('Bussiness.Country_City')}</h3>
                    <address>{t('Bussiness.Direction')}</address>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="easybuy-info-box">
                  <div className="easybuy-info-icon">
                    <i className="la la-envelope"></i>
                  </div>

                  <div>
                    <h3>{t('Bussiness.Conversation')}</h3>

                    <div>
                      <a href="mailto:#">{t('Bussiness.Email')}</a>
                    </div>

                    <div>
                      <a href="tel:#">{t('Bussiness.Phone')}</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="easybuy-info-box">
                  <div className="easybuy-info-icon">
                    <i className="la la-share-alt"></i>
                  </div>

                  <div>
                    <h3>{t('social.social_icons')}</h3>

                    <div className="social-icons social-icons-color easybuy-social-icons">
                      <a
                        href={t('social.social_face_url')}
                        rel="noreferrer"
                        className="social-icon social-facebook"
                        title="Facebook"
                        target="_blank"
                      >
                        <i className={t('social.social_face')}></i>
                      </a>

                      <a
                        href={t('social.social_x_url')}
                        rel="noreferrer"
                        className="social-icon social-twitter"
                        title="Twitter"
                        target="_blank"
                      >
                        <i className={t('social.social_x')}></i>
                      </a>

                      <a
                        href={t('social.social_ins_url')}
                        rel="noreferrer"
                        className="social-icon social-instagram"
                        title="Instagram"
                        target="_blank"
                      >
                        <i className={t('social.social_ins')}></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
